<article class="component-container">
  <section class="login-container color-background-primary">
    <header class="login-container__header">
      <img
        class="login-container__header__logo"
        src="assets/logo-itau.png"
        alt="logotipo do time framework quickweb"
      />
    </header>
    <div class="login-container__content">
      <form [formGroup]="formularioLogin" (ngSubmit)="onSubmit()" method="post">
        <ids-form-field
          class="login-container__formfield"
          label="login"
          errorMessage="preenchimento de RACF obrigatório"
        >
          <input idsInput formControlName="racf" placeholder="digite sua RACF" />
          <ids-icon class="login-container__formfield__color-icon" a11yHidden="false"
            >usuario_outline</ids-icon
          >
        </ids-form-field>
        <ids-form-field
          class="login-container__formfield"
          label="senha"
          errorMessage="preenchimento de senha obrigatório"
        >
          <input
            type="password"
            idsInput
            formControlName="senha"
            placeholder="digite sua senha"
            autoComplete="off"
            autoCorrect="off"
          />
          <ids-icon class="login-container__formfield__color-icon" a11yHidden="false"
            >seguranca_outline</ids-icon
          >
        </ids-form-field>
        <div class="login-container__links">
          <button
            a11yLabel="enviar formulário"
            type="submit"
            idsButton
            [disabled]="!formularioLogin.valid"
            variant="secondary"
          >
            <div *ngIf="loading">acesso</div>
          </button>
          <a idsButtonAction class="login-container__vxlink">esqueci minha senha</a>
          <button variant="dark" idsButtonContextual>Solicitar acesso</button>
        </div>
      </form>
    </div>
  </section>
</article>
